import { useGetPublicDesil } from '@tatatemplate/shared-lib'

/**
 * `select` memetakan envelope kontrak (`{ data, metaData: { pagination } }`) ke bentuk
 * `{ data: { data, pagination } }` yang dibaca komponen grafik di template ini.
 */
export function useDesilByYear(tahun: number, enabled: boolean = true) {
  return useGetPublicDesil(
    { tahun, page: 1, limit: 100 },
    {
      query: {
        queryKey: ['desil', 'year', tahun],
        select: (res) => ({ data: { data: res.data, pagination: res.metaData.pagination } }),
        staleTime: 5 * 60 * 1000,
        retry: 3,
        enabled: enabled && !!tahun,
      },
    },
  )
}
